import React, { Component } from "react";
import { Spin, Select } from "antd";
import axios from "axios";
import debounce from "lodash.debounce";
import './Styles.css';

const { Option } = Select;

class SelectEmpresasBiwoItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      opciones: [],
      cargando: false,
      primerCarga: false,
    };

    this.buscarEmpresas = debounce(this.buscarEmpresas.bind(this), 300);
  }

  componentDidMount() {
    // Cargar los primeros 10 al abrir por primera vez
    this.buscarEmpresas('');
  }

  componentDidUpdate(prevProps) {
    if(prevProps.value !== this.props.value) {
      // Si el valor cambia, reiniciar las opciones
      if(this.props.value){
        const buscarEmpresa = this.state.opciones.find(empresa => empresa._id.toString() === this.props.value.toString());
        if (!buscarEmpresa){
          this.buscarEmpresas(this.props.value || '');
        }
      }
    }
  }

  async buscarEmpresas(texto) {
    this.setState({ cargando: true });
    try {
      const res = await axios.post(
        "empresasBiwo/selectEmpresasBiwoItem",
        {
          empresaId: this.props.empresaId,
          query: texto,
          values: this.props.value
        },
        {
          headers: this.props.headersToken,
        }
      );

      if (res.data.success === 2) {
        this.setState({
          opciones: res.data.empresas,
          primerCarga: true,
        });
      } else {
        this.setState({ opciones: [] });
      }
    } catch (error) {
      console.error("Error al buscar empresas:", error);
      this.setState({ opciones: [] });
    } finally {
      // Asegurar que siempre se quite el loading
      this.setState({ cargando: false });
    }
  }


  render() {
    const {
      noBuscar,
      mode,
      selectAll,
      mostrarCarga,
      onSelectAll,
      disabled,
      fondoBlanco,
      sinBorde,
      width,
      style,
      placeholder,
      ...restProps
    } = this.props;

    const propsNuevas = {
      showSearch: !noBuscar,
      filterOption: false,
      mode: mode,
      onSearch: this.buscarEmpresas,
      // Mostrar loading cuando está cargando, o mensaje cuando no hay resultados
      notFoundContent: this.state.cargando ? (
        <div style={{ textAlign: 'center', padding: '8px' }}>
          <div style={{ marginTop: '8px', fontSize: '12px', color: '#999' }}>
            Buscando empresas...
          </div>
        </div>
      ) : this.state.primerCarga ? 'No se encontraron empresas' : null,
      // Mostrar loading en el input del select
      loading: this.state.cargando,
    };

    if (mode === 'multiple') {
      propsNuevas.maxTagCount = 'responsive';
    }

    const estiloFinal = {
      color: disabled ? 'black' : 'inherit',
      backgroundColor: disabled ? (fondoBlanco ? 'white' : 'white') : null,
      borderBottom: sinBorde ? 'none' : '1px solid #E0FFFFFF',
      borderRadius: '4px',
      transition: 'border-color 0.3s ease',
      boxShadow: sinBorde ? 'none' : '0 1px 3px rgba(0, 0, 0, 0.1)',
      width: width || undefined,
      opacity: disabled ? 1 : undefined,
      ...style,
    };


    return (
      <Select
        className={`custom-disabled-select ${disabled ? "custom-disabled" : ""}`}
        dropdownMatchSelectWidth={400}
        disabled={disabled}
        dropdownRender={(menu) => (
          <Spin spinning={this.state.cargando}>
            {menu}
          </Spin>
        )}
        {...propsNuevas}
        {...restProps}
        onChange={(value) => {
          const empresa = this.state.opciones.find((empresa) => empresa._id === value);
          this.props.onChange(value, empresa)
        }}
        placeholder={this.state.cargando && !this.state.primerCarga ? "Cargando..." : placeholder}
        style={estiloFinal}
        bordered={false}
      >
        {this.state.opciones.map((empresa) => (
          <Option key={empresa._id} value={empresa._id}>
            {empresa.stringBuscar}
          </Option>
        ))}
      </Select>
    );
  }
}

export default SelectEmpresasBiwoItem;